import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import dropdownReducer from '../features/dropdown/dropdownSlice';
import labelReducer from '../features/label/labelSlice';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		dropdown: dropdownReducer,
		label: labelReducer,
	},
});
